/**
 * WorkLocationOption is a constant object that provides a set of predefined work location options with corresponding labels and values.
 *
 * The available options include:
 *   - OnSite: Filter by on-site work locations with a key value of 'on-site'.
 *   - Hybrid: Filter by hybrid work locations with a key value of 'hybrid'.
 *   - Remote: Filter by remote work locations with a key value of 'remote'.
 *
 * @typedef {{label: string, value: string}} WorkLocation
 * @type {Readonly<{string: WorkLocation}>}
 * @enum
 */
export const WorkLocationOption = Object.freeze({
    OnSite: { label: 'On-site', value: 'on-site' },
    Hybrid: { label: 'Hybrid', value: 'hybrid' },
    Remote: { label: 'Remote', value: 'remote' }
});
